import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

// Returns { inProgress: true/false } - whether a demo reset is already running
export const getDemoResetStatus = () => {
  return api.get(URLS.demoReset, {
    headers: {
      needsToken: true
    }
  });
};

export const resetDemoData = (password) => {
  return api.post(
    URLS.demoReset,
    {
      password
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};
